import {
  AppRecordKebabMenuItem,
  AppRecordKebabMenuShowItemCondition,
} from '../../types';

/**
 * Adds additional `show` conditions on top of those pre-defined in existing kebabMenuItems
 * @param {AppRecordKebabMenuItem[]} originalItems the original kebab menu items to modify
 * @param {AppRecordKebabMenuShowItemCondition[]} additionalShowConditions the additional `show` conditions to apply
 * @return {AppRecordKebabMenuItem[]} - the original list of kebab menu items, with the additionalShowConditions applied
 */
export const applyAdditionalKebabMenuItemShowConditions = (
  originalItems: AppRecordKebabMenuItem[],
  additionalShowConditions: AppRecordKebabMenuShowItemCondition[],
): AppRecordKebabMenuItem[] => {
  return originalItems.map((item) => ({
    ...item,
    show: (props) => {
      const additionalShowConditionsResult = additionalShowConditions.every(
        (showCondition) => showCondition(props),
      );
      const originalShow =
        typeof item.show === 'function' ? item.show(props) : true;
      return additionalShowConditionsResult && originalShow;
    },
  }));
};
